import { Box, Container, SxProps, Theme } from "@mui/material";

export const ContentContainer = ({
  children,
  sxProps,
  id,
}: {
  children: React.ReactElement;
  sxProps?: SxProps<Theme>;
  id?: string;
}) => {
  return (
    <Box
      id={id}
      sx={{
        width: { xs: "90%", md: 750 },
        paddingTop: 2,
        ...sxProps,
      }}
    >
      {children}
    </Box>
  );
};
